//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Bodies",0,"SelectTaggedObjectList",0],[0,"ReportContent",1,0]],[[["numStudies"],"GetStudies",{R_:{studies:"DesignSimulation.Study[]"}},0,0],[["studies"],"SetStudies",{},1,0]],[]];
SPLM.DesignSimulation.ViewTabularResultBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.ViewTabularResultBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.ViewTabularResultBuilder.ReportContentOption = Object.freeze({
    "OptimizationObjective" : "OptimizationObjective", "OptimizationConstraint" : "OptimizationConstraint", "All" : "All"});

export default SPLM;